/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Nav_CtaInputs */

const tr_landing_nav_cta = /** @type {(inputs: Landing_Nav_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlayın`)
};

const en_landing_nav_cta = /** @type {(inputs: Landing_Nav_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Started`)
};

const de_landing_nav_cta = /** @type {(inputs: Landing_Nav_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt starten`)
};

const ru_landing_nav_cta = /** @type {(inputs: Landing_Nav_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начать`)
};

/**
* | output |
* | --- |
* | "Get Started" |
*
* @param {Landing_Nav_CtaInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_nav_cta = /** @type {((inputs?: Landing_Nav_CtaInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Nav_CtaInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_nav_cta(inputs)
	if (locale === "de") return de_landing_nav_cta(inputs)
	if (locale === "ru") return ru_landing_nav_cta(inputs)
	return tr_landing_nav_cta(inputs)
});